import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

const FILE_NAME = 'ExportEtzProfileRevenueByMonth.csv';

export const useExportEtzProfileRevenueByMonth = () => {
  const mutate = async () => {
    const { data } = await api.exportEtzProfileRevenueByMonth();
    return data;
  };

  return useMutation<Blob, AxiosError>(mutate, {
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', FILE_NAME);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showInfoToast(Messages.successExportCsv);
    },
  });
};
